import React from 'react';
import PropTypes from 'prop-types';
import ThumbnailUtil from '../util/ThumbnailUtil';
import TextWithEllipsis from './TextWithEllipsis';

export default class ConciseAsset extends React.Component {
  static propTypes = {
    asset: PropTypes.object.isRequired,
    style: PropTypes.object,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    style: {},
    onClick: _.noop,
  };

  render() {
    const { asset, children, onClick } = this.props;
    if (!asset) {
      return null;
    }

    return (
      <div style={{ ...styles.asset, ...this.props.style }} onClick={onClick}>
        <img style={{ width: '32px', height: '32px' ,objectFit: asset && asset.getFrn() === 0?'contain':'cover'}} src={ThumbnailUtil.toThumbUrl(asset)} />
        <TextWithEllipsis text={asset.getName()} style={styles.assetName} />
        {children}
      </div>
    );
  }
}

const styles = {
  asset: {
    width: '100%',
    background: 'var(--primary-header-bg)',
    padding: '5px',
    display: 'flex',
    boxShadow: '0 1px 4px 0 rgba(0,0,0,0.04)',
    fontSize: '14px',
    position: 'relative',
    overflow: 'hidden'
  },
  assetName: {
    margin: 'auto 0.7em',
    color: 'var(--primary-font-color)',
    fontSize: '14px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexGrow: 1 // Right-aligns any child items
  }
};
